var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-content flex-between"},[_c('div',{staticClass:"popup-inner flex-center"},[_c('img',{attrs:{"src":require("@/assets/imgs/app.png"),"alt":""}}),_c('span',[_vm._v("扫码下载客户端")])]),_c('div',{staticClass:"popup-inner flex-center"},[_c('img',{attrs:{"src":require("@/assets/imgs/wx.jpg"),"alt":""}}),_c('span',[_vm._v("扫码进入小程序")])])])
}]

export { render, staticRenderFns }